<template>
  <div class="registration-fee-print">
    <div v-if="tournamentLabel" class="tournament-subtitle" style="text-align: center; font-size: 14px; font-weight: 600; margin: -20px 0 20px 0;">{{ tournamentLabel }}</div>
    <table>
      <thead>
        <tr>
          <th>{{ $tc('form.name') }}</th>
          <th>{{ $tc('settings.discipline') }}</th>
          <th style="text-align: right;">{{ $tc('form.price') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(registration, index) in allData" :key="`${index}-${registration.isTeam ? 'team-' : 'comp-'}${registration.id}`">
          <td>
            <template v-if="registration.isTeam">
              {{ index + 1 }}. {{ getCompetitorNames(registration) }}
              <div v-if="showClubName && registration.club" class="club-name">{{ getClubLabel(registration.club) }}</div>
            </template>
            <template v-else>
              {{ index + 1 }}. {{ registration.competitor ? `${registration.competitor.firstName || ''} ${registration.competitor.lastName || ''}`.trim() || '—' : '—' }}
              <div v-if="showClubName && registration.club" class="club-name">{{ getClubLabel(registration.club) }}</div>
            </template>
          </td>
          <td>
            <div
              v-for="(item, idx) in getDisciplinesDataList(registration.categories)"
              :key="item.label + item.text + idx"
              class="data-list-item">
              <span v-if="item.label" class="label">{{ item.label }}</span>
              <span v-if="item.text" class="text">{{ item.text }}</span>
            </div>
          </td>
          <td style="text-align: right;">{{ registration.isTeam ? getTeamPriceText(registration, hideDiscount || hasClubDiscount(registration)) : getPriceText(registration, hideDiscount || hasClubDiscount(registration)) }} RSD</td>
        </tr>
      </tbody>
    </table>

    <div class="text fee-summary-row">Cena bez popusta: <b>{{ priceOne }} RSD</b></div>
    <div v-if="!hideDiscount && !hasAnyClubDiscount" class="text fee-summary-row">Cena sa popustom: <b>{{ priceTwo }} RSD</b></div>
    <div v-if="hasAnyClubDiscount" class="text fee-summary-row">Popust udruženja: <b>{{ getCostReduction(club) }}%</b> ({{ totalAssociationDiscountAmount }} RSD)</div>
    <div class="text fee-summary-row">Ukupno: <b>{{ hideDiscount ? priceOne : total }} RSD</b></div>
  </div>
</template>

<script>
import registrationFeeMixin from './registration-fee'

export default {
  mixins: [registrationFeeMixin],

  props: {
    data: {
      type: Array,
      required: true
    },

    tournament: {
      type: Object,
      required: true
    },

    hideDiscount: {
      type: Boolean,
      default: false
    },

    teamData: {
      type: Array,
      required: true
    },
    showClubName: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    allData () {
      return [
        ...[...this.data].sort((a, b) => (parseInt(a.club?.id || 0) - parseInt(b.club?.id || 0))),
        ...[...this.teamData].sort((a, b) => (parseInt(a.club?.id || 0) - parseInt(b.club?.id || 0))).map(item => ({
          ...item,
          isTeam: true
        }))
      ]
    },

    club () {
      return this.allData[0]?.club
    },

    tournamentLabel () {
      const first = this.allData[0]
      return first?.tournament?.name || first?.tournamentName || this.tournament?.name || ''
    },

    costReduction () {
      return this.getCostReduction(this.club)
    },

    hasAnyClubDiscount () {
      return this.allData.some(item => item.club?.id && this.getCostReduction(item.club) > 0)
    },

    totalAssociationDiscountAmount () {
      return this.priceOne - this.total
    },

    priceOne () {
      return this.allData.reduce((acc, item) => (item.isTeam ? this.getTeamPrice(item) : this.getPrice(item)) + acc, 0)
    },

    priceTwo () {
      return this.allData.reduce((acc, item) => (item.isTeam ? this.getTeamPrice(item, !this.hideDiscount) : this.getPrice(item, !this.hideDiscount)) + acc, 0)
    },

    total () {
      return this.allData.reduce((acc, item) => {
        const priceWithTournamentDiscount = item.isTeam
          ? this.getTeamPrice(item, true)
          : this.getPrice(item, true)
        const priceWithoutTournamentDiscount = item.isTeam
          ? this.getTeamPrice(item, false)
          : this.getPrice(item, false)
        const deduction = item.club?.id
          ? (this.tournament?.clubDeductions?.find(d => parseInt(d.clubId) === parseInt(item.club.id))?.deduction || 0)
          : 0
        const itemPrice = deduction
          ? ((100 - deduction) / 100) * priceWithoutTournamentDiscount
          : priceWithTournamentDiscount
        return acc + itemPrice
      }, 0)
    }
  },

  methods: {
    getCostReduction (club) {
      if (!club?.id) return 0
      const clubDeductions = this.tournament.clubDeductions || []
      return clubDeductions.find(d => parseInt(d.clubId) === parseInt(club.id))?.deduction || 0
    },

    hasClubDiscount (registration) {
      return !!(registration.club && this.getCostReduction(registration.club))
    },

    getCompetitorNames (item) {
      const keys = ['competitor', 'competitorTwo', 'competitorThree', 'competitorFour']
      const competitors = keys.map(key => item[key]).filter(item => !!item).map(competitor => `${competitor.firstName} ${competitor.lastName}`)
      return competitors.join(', ')
    },

    getDisciplinesDataList (categories) {
      return categories?.reduce((acc, item) => {
        acc.push({ label: item.category?.name })
        const discplines = item.disciplines?.map(disc => ({ text: disc.discipline.name }))
        acc.push(...discplines)
        return acc
      }, [])
    },

    getClubLabel (club) {
      return club?.shortName || club?.name || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.club-name {
  font-size: 0.9em;
  color: #606266;
  margin-top: 2px;
}

.text {
  margin-top: 10px;
  text-align: right;
}
</style>
